import { graphql } from 'src/graphql';

export const CancelParticipantSession = graphql(`
  mutation cancelParticipantSession($booking_id: ID!, $participant_session_id: ID!) {
    cancelParticipantSession(booking_id: $booking_id, participant_session_id: $participant_session_id) {
      _id
    }
  }
`);
